module.exports = __webpack_public_path__ + "static/media/logotextschwarz.a88e0071.png";